import {HiX} from "react-icons/hi";
import {FiMaximize} from "react-icons/fi";
import React from "react";
import {useSelector} from "react-redux";

interface MinimizedChatBoxProps {
  onClick: () => void;
  onCloseChatModal: () => void;
}

const MinimizedChatBox: React.FC<MinimizedChatBoxProps> = ({ onClick, onCloseChatModal }) => {
  const {
    lastActiveChatId,
    chatHistoryByDate,
  } = useSelector((state?: any) => state.chatMessages);

  const handleCloseChatModal = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    onCloseChatModal()
  }

  return (
    <div className="fixed bottom-4 right-4 z-[9998]">
      <div
        className="flex items-center bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-full
          shadow-lg cursor-pointer hover:shadow-xl transition-all duration-300 px-4 py-2 min-w-[200px]"
        onClick={onClick}
      >
        {/* AI Logo */}
        <div className="w-8 h-8 rounded-full bg-gradient-to-tr from-blue-500 to-blue-700 flex items-center justify-center mr-3 flex-shrink-0">
          <img
            src="https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/cadencelogo.webp"
            className="h-5 w-5"
            alt="Cadence AI"
          />
        </div>

        {/* Chat info */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between">
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium text-gray-900 dark:text-white truncate">
                {lastActiveChatId ?
                  (chatHistoryByDate.today.find((chat: any) => chat.chat_id === lastActiveChatId)?.title
                    || chatHistoryByDate.yesterday.find((chat: any) => chat.chat_id === lastActiveChatId)?.title
                    || chatHistoryByDate.older.find((chat: any) => chat.chat_id === lastActiveChatId)?.title
                    || "Ongoing Chat"
                  )
                  : "CadenceAI"}
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400">
                {lastActiveChatId ? "Click to continue" : "Start a conversation"}
              </p>
            </div>

            {/* Close button */}
            <button
              onClick={handleCloseChatModal}
              className="ml-2 p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
              title="Close chat"
            >
              <HiX className="w-4 h-4" />
            </button>
          </div>
        </div>

        {/* Expand icon */}
        <div className="ml-2 flex-shrink-0">
          <FiMaximize className="w-4 h-4 text-gray-400" />
        </div>
      </div>

      {/* Pulse animation indicator for active chat */}
      {lastActiveChatId && (
        <div className="absolute top-0 right-0 w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
      )}
    </div>
  );
}

export default MinimizedChatBox;